export default "__VITE_ASSET__BPElH6KU__"